import {css} from '@isceco/widget-library2/external/lit'

export default css`
  :host {
    display: flex;
    flex-direction: column;
    gap: var(--isceco-space-300);
  }

  .container {
    font-family: var(--isceco-font);
    padding: var(--isceco-space-300);
    border-radius: 4px;
    position: relative;
    border-bottom: 2px solid;
    display: flex;
    flex-direction: row;
    gap: var(--isceco-space-200);
  }

  .container > i {
    flex: 0;
    padding-top: 2px;
  }

  .container > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--isceco-space-200);
  }

  .container > div > * {
    margin: 0;
  }

  .container > div > *:empty {
    display: none;
  }

  .container h3 {
    font-size: 1rem;
  }

  div.warning {
    background-color: var(--isceco-color-yellow-100);
    color: var(--isceco-color-yellow-700);
    border-color: var(--isceco-color-yellow-700);
  }

  div.error {
    background-color: var(--isceco-color-red-100);
    color: var(--isceco-color-red-500);
    border-color: var(--isceco-color-red-500);
  }

  div.success {
    background-color: var(--isceco-color-green-100);
    color: var(--isceco-color-green-500);
    border-color: var(--isceco-color-green-500);
  }

  i.close.icon {
    cursor: pointer;
  }

  ul {
    padding-left: 20px;
  }
`
